/* Pazar degisince sepeti bosaltir.

   Sepetin hangi pazarda kuruldugu "_market" sepet ozniteliginde tutulur.
   Alt cizgiyle basladigi icin musteriye ve siparis ekranina yansimaz.
   Her sayfa acilisinda bu damga guncel pazarla karsilastirilir. */
if (!customElements.get("market-cart-guard")) {
  const MARKET_ATTRIBUTE = "_market";
  const GUARD_KEY = "dimuem-market-guard";

  class MarketCartGuard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === "1") return;
      this.dataset.ready = "1";
      this.run().catch((error) => {
        console.warn("[market-cart-guard] islem tamamlanamadi:", error);
      });
    }

    root() {
      const value = this.dataset.root || "/";
      return value.endsWith("/") ? value : value + "/";
    }

    async postJson(path, body) {
      const response = await fetch(this.root() + path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body || {}),
      });
      if (!response.ok) throw new Error(path + " -> " + response.status);
      return response.json();
    }

    setMarket(market) {
      const attributes = {};
      attributes[MARKET_ATTRIBUTE] = market;
      return this.postJson("cart/update.js", { attributes: attributes });
    }

    async run() {
      const market = this.dataset.market;
      const cartMarket = this.dataset.cartMarket || "";
      const itemCount = parseInt(this.dataset.itemCount, 10) || 0;

      if (!market) return;

      /* Sepet bosken pazari pesinen damgala ki ilk urun dogru damgayla eklensin. */
      if (itemCount === 0) {
        sessionStorage.removeItem(GUARD_KEY);
        if (cartMarket !== market) await this.setMarket(market);
        return;
      }

      /* Bu ozellik gelmeden once olusmus sepetler: sadece damgala, bosaltma. */
      if (!cartMarket) {
        await this.setMarket(market);
        return;
      }

      /* Ayni pazar: yapacak bir sey yok. */
      if (cartMarket === market) {
        sessionStorage.removeItem(GUARD_KEY);
        return;
      }

      /* Bir sey ters giderse sonsuz donguye girmeyelim. */
      if (sessionStorage.getItem(GUARD_KEY) === market) {
        console.warn(
          "[market-cart-guard] bu pazar icin bosaltma zaten denendi:",
          market,
        );
        return;
      }
      sessionStorage.setItem(GUARD_KEY, market);

      await this.postJson("cart/clear.js");
      await this.setMarket(market);
      sessionStorage.removeItem(GUARD_KEY);

      this.refresh();
    }

    /* Sayfayi yeniden yuklemek yerine temanin kendi tazeleme olayini kullan,
       boylece ekran "gidip gelmiyor". Sepet sayfasindaysak yenileme sart. */
    refresh() {
      const cartUrl = (window.routes && window.routes.cart_url) || "/cart";
      if (window.location.pathname === cartUrl) {
        window.location.reload();
        return;
      }
      document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
    }
  }

  customElements.define("market-cart-guard", MarketCartGuard);
}
